// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox, 
// the second argument is the SVG content stripped of SVG tags
export const faqs = ['319 512',`
  
<g  id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M491.422,138.859c-13.008-26.609-32.129-49.151-56.831-66.999C390.803,40.221,329.047,23.5,256,23.5
				S121.197,40.221,77.409,71.859c-24.702,17.848-43.823,40.39-56.831,66.999C6.924,166.791,0,199.305,0,235.5
				c0,78.285,32.285,138.172,93.614,174.195c-8.483,29.931-19.492,48.07-19.591,48.231l-18.984,30.521l35.956,0.053H91.1
				c0.104,0.001,0.208,0.001,0.319,0.001c11.347,0,63.406-2.448,105.735-44.91c18.66,2.596,38.403,3.909,58.846,3.909
				c73.047,0,134.803-16.723,178.591-48.36c24.702-17.848,43.823-40.39,56.831-66.999C505.076,304.208,512,271.693,512,235.5
				C512,199.305,505.076,166.791,491.422,138.859z M411.164,366.716C374.237,393.396,320.583,407.5,256,407.5
				c-22.19,0-43.364-1.686-62.935-5.009l-11.135-1.891l-7.369,8.559c-15.834,18.391-34.114,28.21-49.632,33.439
				c4.03-10.872,8.111-23.919,11.404-38.786l3.394-15.32l-14.072-6.941C68.818,353.515,40,304.375,40,235.5
				c0-57.903,20.468-102.051,60.836-131.217C137.763,77.602,191.417,63.5,256,63.5s118.237,14.103,155.164,40.783
				C451.532,133.448,472,177.596,472,235.5S451.532,337.549,411.164,366.716z"/>
			<rect x="236" y="327.5" width="40" height="40"/>
			<path d="M264.01,105.994c-22.998-2.518-45.895,4.748-62.838,19.936C184.539,140.839,175,162.187,175,184.5h40
				c0-11.122,4.571-21.346,12.871-28.786c8.616-7.724,19.905-11.261,31.781-9.958c18.319,2.008,33.077,16.6,35.093,34.699
				c1.622,14.574-4.888,28.78-16.991,37.072C250.983,235.87,235,265.766,235,297.5h40c0-18.534,9.481-36.094,25.363-46.975
				c24.317-16.662,37.397-45.207,34.136-74.497C330.429,139.477,300.784,110.023,264.01,105.994z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</g>
    
  
`]

